import styles from './ModalRadialProgression.sass'
import * as React from 'react'
import RadialProgress from '../../../../../../components/RadialProgress'
import { observer } from 'mobx-react'

export type ModalRadialProgressionProps = {
  progress: number
  completed: number
  total: number
  withError: boolean
}

export default observer(function ModalRadialProgression({
  progress,
  completed,
  total,
  withError,
}: ModalRadialProgressionProps) {
  return (
    <div className={styles.root}>
      <RadialProgress
        size={150}
        thickness={4}
        progress={progress}
        stroke={withError ? 'var(--red500)' : 'var(--theme-darken)'}
      >
        <div className={styles.info}>
          <div className={styles.percentage}>{progress}%</div>
          <div className={styles.completionCount}>
            <span>{completed}</span> / <span>{total}</span>
          </div>
        </div>
      </RadialProgress>
    </div>
  )
})
